import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Notice = ({ text, controls }) => (
	<div className={styles.notice}>
		<div className={styles.title}>
			<span>{text}</span>
		</div>
		<div className={styles.controls}>
			{controls.map((control) => (
				<div className={styles.block}>
					<button
						className={cx(styles.button, control.mute && styles.mute)}
						type="button"
						onClick={control.onClick}
					>
						{control.text}
					</button>
				</div>
			))}
		</div>
	</div>
);

Notice.propTypes = {
	text: PropTypes.string,
	controls: PropTypes.arrayOf(
		PropTypes.shape({
			text: PropTypes.string.isRequired,
			onClick: PropTypes.func,
			mute: PropTypes.bool
		})
	)
};

export default Notice;
